var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcHomeInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5377 19.3279V14.3279H14.5377V19.3279C14.5377 19.8779 14.9877 20.3279 15.5377 20.3279H18.5377C19.0877 20.3279 19.5377 19.8779 19.5377 19.3279V12.3279H21.2377C21.6977 12.3279 21.9177 11.7579 21.5677 11.4579L13.2077 3.92785C12.8277 3.58785 12.2477 3.58785 11.8677 3.92785L3.5077 11.4579C3.1677 11.7579 3.3777 12.3279 3.8377 12.3279H5.5377V19.3279C5.5377 19.8779 5.9877 20.3279 6.5377 20.3279H9.5377C10.0877 20.3279 10.5377 19.8779 10.5377 19.3279Z",
    fill: "#98A5B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeInactive);
export default __webpack_public_path__ + "static/media/ic_home_inactive.5d007d44e0997d08a9786754d4473010.svg";
export { ForwardRef as ReactComponent };